import { createStore } from "vuex";
import { store as filter, FilterStore, State as FilterState } from "./modules/filter/index";
import { store as product, ProductStore, State as ProductState } from "./modules/product/index";

export type RootState = {
    filter: FilterState;
    product: ProductState;
};

export type Store = FilterStore<Pick<RootState, 'filter'>>
    & ProductStore<Pick<RootState, 'product'>>;

export const store = createStore({
    modules: {
        filter,
        product,
    },
});

export function useStore(): Store {
    return store as Store;
}